<script>
  import { computed } from '@nuxtjs/composition-api'
  import ProductPrice from '@/components/Ecommerce/Products/ProductPrice'
  import ProductFreeShipping from '@/components/Ecommerce/Products/ProductFreeShipping'

  export default {
    components: {
      ProductPrice,
      ProductFreeShipping
    },
    props: {
      amount: {
        type: Number,
        required: true
      }
    },
    setup (props) {
      const freeShipping = computed(() => {
        return [0.00, 0].includes(props.amount)
      })

      return {
        freeShipping
      }
    }
  }
</script>

<template>
  <div class="space-y-5">
    <div class="flex items-center justify-between">
      <span>
        Verzendkosten
      </span>
      <span
        v-if="freeShipping"
        class="text-blue-600 font-bold text-base md:text-lg"
      >
        gratis
      </span>
      <ProductPrice
        v-else
        :price="amount"
        show-decimals
      />
    </div>
    <ProductFreeShipping v-if="!freeShipping" />
  </div>
</template>

<style scoped>

</style>
